import type { TextData } from '../api/types'

export interface WebhookVariableHelp {
  token: string
  description: string
}

/**
 * The "possible variables for url and data fields" help table — legacy
 * `momentum-edit.component.html:426-513` (the built-ins) plus `@SOURCE@` and
 * per-`TextData` `@<NAME>@` tokens, which the legacy template also lists
 * (`html:495-510`) but which are documented separately in the backend
 * (`api.cryptopairscreener.com`'s `app/momentum/webhook.py`): substitution
 * precedence is built-ins, then TextData, then `@SOURCE@`, TextData names are
 * upper-cased, and `@COINPAIR@` is `COIN1` and `COIN2` joined with NO
 * separator (confirmed against `tests/golden/momentum_webhook_golden.json`
 * — legacy's `Calculator.php`, NOT `COIN1_COIN2` as an earlier draft of the
 * port plan guessed). Unknown `@X@` tokens are left verbatim by the backend.
 */
export function webhookVariableHelp(textDatas: TextData[]): WebhookVariableHelp[] {
  const builtins: WebhookVariableHelp[] = [
    { token: '@MOMENTUMID@', description: 'The id of this momentum' },
    { token: '@INDICATOR@', description: 'The indicator, on which the momentum has been triggered' },
    { token: '@EXCHANGEID@', description: "The exchange's id, on which the momentum has been triggered" },
    { token: '@TRADINGTYPE@', description: 'The trading type, on which the momentum has been triggered' },
    { token: '@COIN1@', description: 'The coin, on which the momentum has been triggered' },
    { token: '@COIN2@', description: 'The coin, on which the momentum has been triggered' },
    { token: '@COINPAIR@', description: '@COIN1@ and @COIN2@ joined with no separator, e.g. BTCUSDT' },
    { token: '@INTERVAL@', description: 'The interval, on which the momentum has been triggered' },
    { token: '@SOURCE@', description: "The momentum's source: 'cd' (candle) or 'cl' (closed price)" },
  ]
  const textDataVariables = textDatas
    .filter((textData) => textData.name)
    .map((textData) => ({
      token: `@${textData.name.toUpperCase()}@`,
      description: textData.description || textData.name,
    }))
  return [...builtins, ...textDataVariables]
}
